/* Blaze Amsterdam — Press Edition layout on top of the existing theme.
   Builds the header, footer and home page; the collection and product pages keep
   the theme's own markup and are restyled in blaze-press-style.css. */
(function () {
  // In the Shopify theme, snippets/blaze-press.liquid sets BLAZE_ASSETS (the theme's asset folder, where all
  // files sit side by side) and BLAZE_HERO_VIDEO; the local preview serves everything from /__preview/.
  var LIVE = !!window.BLAZE_ASSETS;
  var ASSETS = window.BLAZE_ASSETS || '/__preview/';
  var LOGO_DIR = LIVE ? '' : 'logos/';
  var HOME = document.documentElement.classList.contains('bp-home');
  // preview only: ?zwart shows the bar, logos and subscribe card over the film in black instead of white
  if (!LIVE && /[?&]zwart/.test(location.search)) document.documentElement.classList.add('bp-black-test');

  // preview only: a typeface picked on /__preview/fonts.html replaces the default one
  if (!LIVE) try {
    var pick = (localStorage.getItem('bp-font') || '').split('|');
    if (pick[1]) {
      if (pick[1].indexOf('local:') === 0) {
        // a font file that sits next to this script (the narrowed Blaze Mono cuts)
        var face = document.createElement('style');
        face.textContent = '@font-face{font-family:"' + pick[0] + '";src:url("' + ASSETS + pick[1].slice(6) + '") format("opentype")}';
        document.head.appendChild(face);
      } else {
        var sheet = document.createElement('link');
        sheet.rel = 'stylesheet';
        sheet.href = 'https://fonts.googleapis.com/css2?family=' + pick[1] + '&display=swap';
        document.head.appendChild(sheet);
      }
      document.documentElement.style.setProperty('--bp-font', '"' + pick[0] + '", "Courier New", monospace');
    }
  } catch (e) {}

  // preview only: a typeface for the menu and the prices, picked on /__preview/menu-fonts.html
  if (!LIVE) try {
    var ui = JSON.parse(localStorage.getItem('bp-ui') || 'null');
    if (ui && ui.family) {
      if (ui.param) {
        var uiSheet = document.createElement('link');
        uiSheet.rel = 'stylesheet';
        uiSheet.href = 'https://fonts.googleapis.com/css2?family=' + ui.param + '&display=swap';
        document.head.appendChild(uiSheet);
      }
      var rootStyle = document.documentElement.style;
      rootStyle.setProperty('--bp-ui-font', ui.family);
      rootStyle.setProperty('--bp-ui-weight', ui.weight || 400);
      rootStyle.setProperty('--bp-ui-stretch', ui.stretch || '100%');
      rootStyle.setProperty('--bp-ui-size', (ui.size || 12) + 'px');
      rootStyle.setProperty('--bp-ui-case', ui.caps ? 'uppercase' : 'none');
      rootStyle.setProperty('--bp-ui-track', ui.caps ? (ui.track || '0.06em') : '0');
    }
  } catch (e) {}

  // menu names as in the shop's own menus, without capitals
  var NAV_LEFT = [['Shop all', '/collections/fw26'], ['Blaze Base', '/collections/blaze-base'], ['Blaze (Re)made', '/collections/blaze-base-1']];
  var NAV_RIGHT = [['About', '/pages/about-1'], ['Contact', '/pages/contact-us'], ['Account', '/account']];
  // the menus as set in Shopify (Online Store > Navigation), written into the page by snippets/blaze-press.liquid;
  // the lists above are only the fallback for when a menu is missing
  function shopMenu(name) {
    var m = window.BLAZE_MENUS && window.BLAZE_MENUS[name];
    return m && m.length ? m.map(function (l) { return [l.t, l.u]; }) : null;
  }
  var mainMenu = shopMenu('main');
  if (mainMenu) {
    // About, Contact and Account keep their place on the right; everything else in the main menu goes left, in the menu's order
    var rightOnly = /^(about|contact|account)\b/i;
    NAV_LEFT = mainMenu.filter(function (l) {
      return !rightOnly.test(l[0]) && !NAV_RIGHT.some(function (r) { return r[1] === l[1]; });
    });
  }
  var FOOT = [
    [['About', '/pages/about-1'], ['Contact', '/pages/contact-us'], ['Store locator', '/pages/store-locator'], ['B2B signup', '/pages/wholesale-signup-form']],
    [['Return & exchanges', '/pages/kopie-van-how-we-work'], ['Delivery & shipping', '/pages/kopie-van-how-we-work'], ['Terms of service', '/pages/terms-of-service'], ['Privacy policy', '/pages/privacy-policy']],
    [['Instagram', 'https://www.instagram.com/blaze.amsterdam/'], ['TikTok', 'https://www.tiktok.com/@blaze.amsterdam'], ['Facebook', 'https://www.facebook.com/blazeamsterdamm']]
  ];
  // home: hero file, press logos and the shops from the store locator
  // the ring binder film; the still shows straight away and stays if the film cannot play
  var HERO_VIDEO = LIVE ? (window.BLAZE_HERO_VIDEO || '') : ASSETS + 'hero.mp4?v=1080', HERO_POSTER = ASSETS + 'hero-poster.jpg';
  var INSTAGRAM = 'https://www.instagram.com/blaze.amsterdam/';
  // [name, logo file or null (shown as text), true when the logo file has a solid background]
  var PRESS = [['Vogue', 'press-vogue.svg'], ['JAN', 'press-jan.svg'], ['LINDA.', 'press-linda-ink.png'], ['&C', 'press-andc.svg'], ['Harper’s Bazaar', 'press-harpers-bazaar.svg']];
  // the shops that sell Blaze now, in the order of the user's list (2026-10-14);
  // [name, webshop, logo file or null (shown as text), solid background (or 'invert' for a light logo on a dark block), tall logo]
  // [name, site, logo file, optional size factor for logos that look small at the same area]
  var STORES = [
    ['Van Tilburg', 'https://www.vantilburgonline.nl/', 'store-van-tilburg-ink.png'],
    ['By Lotte', 'https://www.bylotte.nl', 'store-by-lotte-ink.png'],
    ['Mayke Style Department', 'https://www.mayke.com/', 'store-mayke-ink.png'],
    ['Derksen & Derksen', 'https://www.derksenenderksen.nl/', 'store-derksen-ink.png'],
    ['Rosmode', 'https://www.rosmode.nl/', 'store-rosmode-ink.png'],
    ['Lutz', 'https://www.lutz.nl/', 'store-lutz-ink.png'],
    ['Juul Den Bosch', 'https://juulfashion.nl/', 'store-juul-den-bosch-ink.png', 1.15],
    ['By Kim', 'https://www.kimfashionstore.nl/', 'store-by-kim-ink.png'],
    ['Van Zuilen', 'https://www.vanzuilenmode.nl/', 'store-van-zuilen-ink.png', 1.1],
    ['Black', 'https://www.black-online.nl/', 'store-black-ink.png'],
    ['Assem Borne', 'https://www.assem.nl/boutiques/leurink-by-assem/', 'store-assem-ink.png'],
    ['Bij Marlies', 'https://bijmarlies.nl/', 'store-bij-marlies-ink.png', 1.5],
    ['Jackie O.', 'https://www.jackieo.nl/', 'store-jackie-o-ink.png'],
    ['Noah', 'https://www.noahoosterbeek.nl', 'store-noah-ink.png'],
    ['Toute Fabienne', 'https://toute-fabienne.nl/', null],
    ['Camelot', 'https://www.camelotfashion.nl/', 'store-camelot-ink.png'],
    ['Van Dort', 'https://www.vandortmode.nl/', 'store-van-dort-ink.png'],
    ['Ruys', 'https://www.ruysfashion.nl/', 'store-ruys-ink.png', 0.9],
    ['Biblos', 'https://www.biblos.nl/', 'store-biblos-ink.png'],
    ['Van der Kam', 'https://www.vanderkam.nl/', null],
    ['Bouclé', 'https://boucle.nl/', 'store-boucle-ink.png'],
    ['BY DRÉ', null, null]
  ];

  function el(html) { var t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstChild; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function links(list) { return list.map(function (l) { return '<a href="' + l[1] + '">' + esc(l[0]) + '</a>'; }).join(''); }
  function price(text) { return String(text).replace(/\s*EUR\b/i, '').replace(/\s+/g, ' ').trim(); }

  /* ---------- header ---------- */
  // where each letter of BLAZE® sits in logo-blaze.png (1224 px wide): [left, width]
  var LOGO_W = 1224;
  var LETTERS = [[0, 256], [256, 206], [462, 263], [725, 240], [965, 207], [1172, 52]];
  var ICON_SEARCH = '<svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.1"><circle cx="6.6" cy="6.6" r="5.2"/><path d="M10.5 10.5 15 15"/></svg>';
  var ICON_BAG = '<svg viewBox="0 0 14 17" width="14" height="17" fill="none" stroke="currentColor" stroke-width="1.1"><path d="M.6 3.6h12.8v12.8H.6z"/><path d="M4.4 3.4V.6h5.2v2.8"/></svg>';
  var header = el(
    '<header class="bp-header">' +
      '<button class="bp-burger" type="button" aria-label="Menu" aria-expanded="false"><span></span><span></span><span></span></button>' +
      '<nav class="bp-nav" aria-label="Shop">' + links(NAV_LEFT) + '</nav>' +
      '<a class="bp-logo" href="/" aria-label="Blaze Amsterdam"><span class="bp-letters">' + LETTERS.map(function (c, i) {
        // one slice of the logo file per letter, so the letters can move on their own
        return '<span style="--o:' + Math.min(i, LETTERS.length - 1 - i) + ';width:' + (c[1] / LOGO_W * 100) + '%;background-size:' + (LOGO_W * 100 / c[1]) + '% 100%;background-position:' + (c[0] / (LOGO_W - c[1]) * 100) + '% 0"></span>';
      }).join('') + '</span></a>' +
      '<nav class="bp-nav bp-nav-right" aria-label="Account">' + links(NAV_RIGHT) + '<a href="/cart">Bag (<span class="bp-count">0</span>)</a></nav>' +
      '<div class="bp-icons"><a href="/cart" aria-label="Bag">' + ICON_BAG + '</a></div>' +
    '</header>');
  // the shop links on top, About, Contact and Account at the bottom of the menu
  var drawer = el('<nav class="bp-drawer" aria-label="Menu" hidden>' + links(NAV_LEFT) + '<div class="bp-drawer-foot">' + links(NAV_RIGHT) + '</div></nav>');
  document.body.insertBefore(drawer, document.body.firstChild);
  document.body.insertBefore(header, drawer);

  var burger = header.querySelector('.bp-burger');
  var home = null; // filled in below on the home page
  var filmEdge = 0; // home: how far you can scroll before the film is out from under the bar (measured, not read while scrolling)
  function paintHeader() {
    // home: clear with white print while the film is behind the bar, paper with black print after that
    var over = false;
    if (HOME && home && drawer.hidden) {
      if (!filmEdge) filmEdge = home.querySelector('.bp-hero').offsetHeight - header.offsetHeight;
      over = window.scrollY < filmEdge;
    }
    header.classList.toggle('bp-over', over);
    // the subscribe card follows the bar: see-through over the film, paper after that
    var sub = document.querySelector('.bp-sub');
    if (sub) sub.classList.toggle('bp-sub--over', over);
  }
  burger.addEventListener('click', function () {
    drawer.hidden = !drawer.hidden;
    burger.setAttribute('aria-expanded', String(!drawer.hidden));
    paintHeader();
  });
  // on the home page the bar is repainted in the same frame as the logo (see placeLogo)
  if (!HOME) window.addEventListener('scroll', paintHeader, { passive: true });
  window.addEventListener('resize', function () { filmEdge = 0; paintHeader(); });

  function bagCount() {
    fetch('/cart.js', { headers: { accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      header.querySelector('.bp-count').textContent = c.item_count;
    }).catch(function () {});
  }
  bagCount();
  document.addEventListener('submit', function () { setTimeout(bagCount, 1500); }, true);

  /* ---------- footer ---------- */
  document.body.appendChild(el(
    '<footer class="bp-footer"><div class="bp-foot">' +
      '<div class="bp-est">Est. 2019<br>Amsterdam<img class="bp-copy-b" src="' + ASSETS + 'logo-b-mark.png" alt=""></div>' +
      FOOT.map(function (col) { return '<div class="bp-col">' + links(col) + '</div>'; }).join('') +
      '<form class="bp-news" method="post" action="/contact#contact_form" accept-charset="UTF-8">' +
        '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="contact[tags]" value="newsletter">' +
        '<label for="bp-email">Subscribe and get early access to our limited drops</label>' +
        '<input id="bp-email" type="email" name="contact[email]" placeholder="Enter your email..." required>' +
        '<button type="submit">Subscribe</button>' +
      '</form>' +
    // bottom of the page: the wordmark across the full width
    '</div><div class="bp-copy"><img class="bp-copy-word" src="' + ASSETS + 'logo-blaze.png" alt="Blaze"></div></footer>'));

  /* ---------- newsletter: sign up without leaving the page ---------- */
  var THANKS = 'Thank you, you are subscribed.';
  var subscribed = false;
  try { subscribed = localStorage.getItem('bp-subscribed') === '1'; } catch (e) {}
  // Shopify's own fallback: after a normal form post the page comes back with ?customer_posted=true
  var justPosted = /[?&]customer_posted=true/.test(location.search);
  function markSubscribed() {
    subscribed = true;
    try { localStorage.setItem('bp-subscribed', '1'); } catch (e) {}
  }
  // sends the form in the background; when Shopify asks for a spam check, the form is sent the normal way
  function wireNews(form, onDone) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var button = form.querySelector('button[type="submit"]');
      if (button) { button.disabled = true; button.textContent = '...'; }
      fetch(form.getAttribute('action').split('#')[0], { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .then(function (r) {
          if (r.ok && /customer_posted=true/.test(r.url)) {
            markSubscribed();
            onDone();
          } else {
            form.submit();
          }
        })
        .catch(function () { form.submit(); });
    });
  }
  wireNews(document.querySelector('.bp-news'), function () {
    var news = document.querySelector('.bp-news');
    news.innerHTML = '<p class="bp-news-done">' + THANKS + '</p>';
  });

  /* ---------- subscribe card, bottom right; once closed it stays away for the rest of the visit
     (sessionStorage) and is back on the next visit. Once someone has subscribed it says thank you,
     then goes and stays away for good. ---------- */
  var subClosed = false;
  try { subClosed = sessionStorage.getItem('bp-sub-closed') === '1'; } catch (e) {}
  if ((!subscribed && !subClosed) || justPosted) {
    var subCard = el(
      '<aside class="bp-sub" aria-label="Newsletter">' +
        '<button class="bp-sub-close" type="button" aria-label="Close">×</button>' +
        '<p class="bp-sub-title">Subscribe</p>' +
        '<p class="bp-sub-text">Get early access to our limited drops.</p>' +
        '<form method="post" action="/contact#contact_form" accept-charset="UTF-8">' +
          '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="contact[tags]" value="newsletter">' +
          '<label class="bp-sub-label" for="bp-sub-email">Email</label>' +
          '<input id="bp-sub-email" type="email" name="contact[email]" placeholder="Enter your email..." required>' +
          '<button type="submit">Subscribe</button>' +
        '</form>' +
      '</aside>');
    // start in the see-through look on the film, so it does not fade in from paper on load
    if (HOME && window.scrollY < 100) subCard.classList.add('bp-sub--over');
    document.body.appendChild(subCard);
    subCard.querySelector('.bp-sub-close').addEventListener('click', function () {
      try { sessionStorage.setItem('bp-sub-closed', '1'); } catch (e) {}
      subCard.remove();
    });
    var thankAndGo = function () {
      subCard.querySelector('form').remove();
      subCard.querySelector('.bp-sub-text').textContent = THANKS;
      setTimeout(function () {
        subCard.classList.add('bp-sub--gone');
        setTimeout(function () { subCard.remove(); }, 600);
      }, 3500);
    };
    wireNews(subCard.querySelector('form'), thankAndGo);
    if (justPosted) { markSubscribed(); thankAndGo(); }
    paintHeader();
  }

  /* ---------- text clean-up on theme pages: no "EUR", no all-caps ---------- */
  function tidy(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), node;
    while ((node = walker.nextNode())) {
      var parent = node.parentNode;
      if (!parent || /^(SCRIPT|STYLE|TEXTAREA|NOSCRIPT)$/.test(parent.nodeName)) continue;
      var text = node.nodeValue, out = text;
      if (/\d\s*EUR\b/.test(out)) out = out.replace(/\s*EUR\b/, '');
      if (/[A-Z]{4,}/.test(out) && !/[a-z]/.test(out)) {
        out = out.toLowerCase().replace(/(^|[\s(\/>-])([a-zà-ÿ])/g, function (m, a, b) { return a + b.toUpperCase(); });
      }
      if (out !== text) node.nodeValue = out;
    }
  }
  var main = document.getElementById('MainContent');
  if (main) {
    tidy(main);
    var pending;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(function () { tidy(main); }, 60);
    }).observe(main, { childList: true, subtree: true });
  }

  function card(p) {
    // the second photo sits under the first and shows on hover, as in the collection
    return '<a class="bp-card" href="' + p.url + '"><span class="bp-card-media"><img src="' + p.img + '" alt="' + esc(p.title) + '" loading="lazy">' +
      (p.img2 ? '<img class="bp-card-alt" src="' + p.img2 + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span class="bp-meta"><span class="bp-name">' + esc(p.title) + '</span><span>' + esc(p.price) + '</span></span></a>';
  }

  /* ---------- products of the collections that are in the menu ---------- */
  var MENU_COLLECTIONS = NAV_LEFT.map(function (l) { return l[1].split('/collections/')[1]; });
  var menuCache = null;
  // resolves to [{handle, title, price, img, collections: [...]}], each product once
  function menuProducts() {
    if (menuCache) return menuCache;
    menuCache = Promise.all(MENU_COLLECTIONS.map(function (c) {
      return fetch('/collections/' + c + '/products.json?limit=250').then(function (r) { return r.json(); })
        .then(function (d) { return { collection: c, products: d.products || [] }; });
    })).then(function (sets) {
      var byHandle = {}, list = [];
      sets.forEach(function (set) {
        set.products.forEach(function (p) {
          if (!byHandle[p.handle]) {
            var img = (p.images[0] || {}).src || '', img2 = (p.images[1] || {}).src || '';
            byHandle[p.handle] = {
              handle: p.handle, url: '/products/' + p.handle, title: p.title, collections: [],
              price: '€' + String((p.variants[0] || {}).price || '').replace('.', ','),
              img: img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=600',
              img2: img2 ? img2 + (img2.indexOf('?') > -1 ? '&' : '?') + 'width=600' : ''
            };
            list.push(byHandle[p.handle]);
          }
          byHandle[p.handle].collections.push(set.collection);
        });
      });
      return list;
    });
    return menuCache;
  }

  /* ---------- product page: you may also like ---------- */
  var productHandle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
  if (productHandle && main) {
    menuProducts().then(function (all) {
      var self = all.filter(function (p) { return p.handle === productHandle; })[0];
      var mine = self ? self.collections : [];
      var others = all.filter(function (p) { return p.handle !== productHandle; });
      // same collection first; the order is shuffled per product, but stays the same on every visit
      var seed = 0;
      for (var i = 0; i < productHandle.length; i++) seed = (seed * 31 + productHandle.charCodeAt(i)) % 9973;
      others.forEach(function (p, n) {
        var shared = p.collections.some(function (c) { return mine.indexOf(c) > -1; });
        p.rank = (shared ? 0 : 10000) + ((n + 1) * (seed + 7)) % 997;
      });
      others.sort(function (a, b) { return a.rank - b.rank; });
      var picks = others.slice(0, 4);
      if (!picks.length) return;
      main.appendChild(el('<section class="bp-also"><h2 class="bp-label">You may also like</h2><div class="bp-also-grid">' + picks.map(card).join('') + '</div></section>'));
    }).catch(function () {});
  }

  /* ---------- collection page: every product on one page ---------- */
  var grid = document.querySelector('.product-grid');
  if (grid && /\/collections\//.test(location.pathname)) {
    var pager = document.querySelector('.pagination');
    // the other pages of this collection, as the theme's own page links give them (filters included)
    var pages = pager ? [].slice.call(pager.querySelectorAll('a[href*="page="]')).map(function (a) { return a.getAttribute('href'); })
      .filter(function (h, i, all) { return all.indexOf(h) === i; }) : [];
    Promise.all(pages.map(function (href) {
      return fetch(href, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var found = [].slice.call(new DOMParser().parseFromString(html, 'text/html').querySelectorAll('.product-grid > .grid__item'));
        if (window.console) console.log('[blaze] ' + href + ': ' + found.length + ' products');
        return found;
      }).catch(function (e) { if (window.console) console.log('[blaze] ' + href + ' failed: ' + e.message); return []; });
    })).then(function (more) {
      var added = 0;
      more.forEach(function (items) { items.forEach(function (li) { grid.appendChild(document.importNode(li, true)); added++; }); });
      // only when the other pages really came in: hide the page numbers
      if (pages.length && added && pager) pager.style.display = 'none';
    });
  }

  /* ---------- home ---------- */
  if (!HOME || !main) return;

  // one logo (or the name as text when there is no usable logo file), linked when there is a webshop
  function mark(name, url, file, solid, tall) {
    var cls = (solid === 'invert' ? 'bp-invert ' : solid ? 'bp-solid ' : '') + (tall ? 'bp-tall' : '');
    var inner = file ? '<img src="' + ASSETS + LOGO_DIR + file + '" alt="' + esc(name) + '"' + (cls ? ' class="' + cls.trim() + '"' : '') + '>' : esc(name);
    return url ? '<a href="' + url + '" target="_blank" rel="noopener" aria-label="' + esc(name) + '">' + inner + '</a>' : '<span>' + inner + '</span>';
  }
  // a store logo: sized so every logo covers about the same area, whatever its shape
  function storeMark(name, url, file, k) {
    var inner = file ? '<img class="bp-store-logo" src="' + ASSETS + LOGO_DIR + file + '" alt="' + esc(name) + '"' + (k ? ' data-k="' + k + '"' : '') + '>' : '<span class="bp-store-name">' + esc(name) + '</span>';
    return url ? '<a href="' + url + '" target="_blank" rel="noopener" aria-label="' + esc(name) + '">' + inner + '</a>' : '<span>' + inner + '</span>';
  }
  function sizeStoreLogo(img) {
    var r = img.naturalWidth / img.naturalHeight;
    if (!r) return;
    var area = (window.innerWidth < 810 ? 2300 : 3600) * Math.pow(+img.dataset.k || 1, 2);
    var h = Math.min(Math.sqrt(area / r), window.innerWidth < 810 ? 46 : 60);
    img.style.height = h.toFixed(1) + 'px';
    img.style.width = (h * r).toFixed(1) + 'px';
  }
  // a band that keeps moving across the width; the set is repeated so the loop has no seam
  function band(items, repeat, reverse) {
    var set = '';
    for (var i = 0; i < repeat; i++) set += items;
    return '<div class="bp-marquee' + (reverse ? ' bp-marquee--reverse' : '') + '"><div class="bp-track"><div class="bp-set">' + set + '</div><div class="bp-set" aria-hidden="true">' + set + '</div></div></div>';
  }

  home = el(
    '<div class="bp-home-main">' +
      '<section class="bp-hero">' + (HERO_VIDEO
        ? '<video src="' + HERO_VIDEO + '" poster="' + HERO_POSTER + '" autoplay muted loop playsinline webkit-playsinline disablepictureinpicture disableremoteplayback preload="auto" aria-label="Blaze Amsterdam Fall Winter ’26"></video>'
        : '<img src="' + HERO_POSTER + '" alt="Blaze Amsterdam Fall Winter ’26">') + '</section>' +
      '<section class="bp-best"><h2 class="bp-label">Best sellers</h2><div class="bp-row"></div><div class="bp-progress"><i></i></div></section>' +
      '<section class="bp-section"><h2 class="bp-title">As seen in</h2>' + band(PRESS.map(function (p) { return mark(p[0], null, p[1], p[2]); }).join(''), 4) + '</section>' +
      '<section class="bp-section bp-insta"><h2 class="bp-title">Take a look at our Instagram</h2><div class="bp-row"></div>' +
        '<a class="bp-button" href="' + INSTAGRAM + '" target="_blank" rel="noopener">Follow us on Instagram</a></section>' +
      '<section class="bp-section"><h2 class="bp-title">Where to buy Blaze Amsterdam?</h2>' + band(STORES.map(function (s) { return storeMark(s[0], s[1], s[2], s[3]); }).join(''), 2, true) + '</section>' +
    '</div>');
  main.appendChild(home);
  // the film plays like a gif: muted, inline, looping, with no play button. Phones only autoplay a video they know
  // is muted, so that is set on the element itself; if the phone still holds it back (Low Power Mode),
  // it starts at the first touch or scroll.
  var film = home.querySelector('.bp-hero video');
  if (film) {
    film.muted = true;
    film.defaultMuted = true;
    film.playsInline = true;
    var playFilm = function () {
      var p = film.play();
      if (p && p.catch) p.catch(function () {});
    };
    playFilm();
    film.addEventListener('canplay', playFilm);
    film.addEventListener('pause', function () { if (!document.hidden && !film.ended) playFilm(); });
    ['touchstart', 'scroll', 'click'].forEach(function (type) {
      window.addEventListener(type, function once() {
        if (film.paused) playFilm();
        window.removeEventListener(type, once);
      }, { passive: true });
    });
    document.addEventListener('visibilitychange', function () { if (!document.hidden && film.paused) playFilm(); });
  }
  var storeLogos = [].slice.call(home.querySelectorAll('img.bp-store-logo'));
  storeLogos.forEach(function (img) {
    if (img.complete) sizeStoreLogo(img); else img.addEventListener('load', function () { sizeStoreLogo(img); });
  });
  window.addEventListener('resize', function () { storeLogos.forEach(sizeStoreLogo); });
  paintHeader();
  window.addEventListener('load', paintHeader);
  // the logo starts large in the middle of the film and, as you scroll, shrinks up into the bar
  var heroLogo = header.querySelector('.bp-logo');
  var heroLetters = heroLogo.querySelector('.bp-letters');
  var logoTicking = false;
  // a small white B with ® waits in the bar where the wordmark will land, and fades out as you scroll
  var barB = el('<span class="bp-bar-b" aria-hidden="true"><img src="' + ASSETS + 'logo-b-mark.png" alt=""></span>');
  header.appendChild(barB);
  // The letters are drawn at the large size and scaled down towards the bar, never enlarged from the small
  // size: that keeps them sharp. The link keeps its normal width, so the menu next to it does not move.
  // Sizes are measured once (and again on resize); while scrolling only transforms and opacity change,
  // so the phone never has to lay the page out again mid-scroll.
  var logoSize = null;
  function measureLogo() {
    heroLetters.style.width = '';
    heroLetters.style.marginLeft = '';
    heroLetters.style.transform = '';
    heroLogo.style.width = '';
    heroLogo.style.transform = '';
    var hero = home.querySelector('.bp-hero');
    var base = heroLetters.offsetWidth;
    if (!base) { logoSize = null; return; }
    var big = window.innerWidth < 810 ? window.innerWidth * 0.5 : (Math.min(window.innerWidth * 0.7, 1000) - 190) * 0.5;
    logoSize = { base: base, big: big, heroH: hero.offsetHeight, headH: header.offsetHeight };
    filmEdge = logoSize.heroH - logoSize.headH;
    heroLogo.style.width = base + 'px';
    heroLetters.style.width = big + 'px';
    heroLetters.style.marginLeft = ((base - big) / 2) + 'px';
  }
  function placeLogo() {
    logoTicking = false;
    paintHeader();
    if (!logoSize) measureLogo();
    if (!logoSize) return;
    var L = logoSize;
    var p = Math.min(1, Math.max(0, window.scrollY / (L.heroH * 0.6)));
    var e = p * p * (3 - 2 * p); // ease in and out
    barB.style.opacity = Math.max(0, 1 - p * 2.5).toFixed(3); // gone well before the wordmark arrives
    var now = L.base + (L.big - L.base) * (1 - e);
    heroLetters.style.transform = 'scale(' + (now / L.big).toFixed(4) + ')';
    heroLogo.style.transform = e >= 1 ? '' : 'translate3d(0,' + ((L.heroH / 2 - L.headH / 2) * (1 - e)).toFixed(1) + 'px,0)';
  }
  function queueLogo() {
    if (!logoTicking) { logoTicking = true; requestAnimationFrame(placeLogo); }
  }
  placeLogo();
  window.addEventListener('scroll', queueLogo, { passive: true });
  // phones change the window height while the address bar slides in and out: only a width change needs a new measurement
  var lastW = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastW && logoSize) return;
    lastW = window.innerWidth;
    logoSize = null;
    queueLogo();
  });
  window.addEventListener('load', function () { logoSize = null; queueLogo(); });


  // phones do not always report every scroll step; also repaint the bar and the subscribe card
  // whenever the film enters or leaves the screen
  if ('IntersectionObserver' in window) {
    var steps = [];
    for (var t = 0; t <= 4; t++) steps.push(t / 4);
    new IntersectionObserver(paintHeader, { threshold: steps }).observe(home.querySelector('.bp-hero'));
  }

  // the shops move as slowly as the press logos: "As seen in" keeps its 60 seconds per round,
  // and every other band gets the duration that gives it the same speed
  function bandSpeed() {
    var tracks = [].slice.call(home.querySelectorAll('.bp-track'));
    var first = tracks[0] && tracks[0].querySelector('.bp-set');
    if (!first || !first.offsetWidth) return;
    var speed = first.offsetWidth / 60; // pixels per second
    tracks.forEach(function (track) {
      var set = track.querySelector('.bp-set');
      if (set && set.offsetWidth) track.style.animationDuration = (set.offsetWidth / speed) + 's';
    });
  }
  bandSpeed();
  window.addEventListener('load', bandSpeed);
  window.addEventListener('resize', bandSpeed);

  // best sellers: the shop's own best-selling order
  var row = home.querySelector('.bp-best .bp-row'), bar = home.querySelector('.bp-progress i');
  // (only products that sit in a collection from the menu)
  Promise.all([
    fetch('/collections/all?sort_by=best-selling').then(function (r) { return r.text(); }),
    menuProducts()
  ]).then(function (got) {
    var doc = new DOMParser().parseFromString(got[0], 'text/html');
    var inMenu = {};
    got[1].forEach(function (p) { inMenu[p.url] = true; });
    var items = [].slice.call(doc.querySelectorAll('.product-grid .grid__item')).map(function (li) {
      var a = li.querySelector('.card-information__text a'), imgs = li.querySelectorAll('img'), img = imgs[0], pr = li.querySelector('.price-item');
      var big = function (i) { return i.getAttribute('src').replace(/_\d+x(\.\w+)/, '_600x$1'); };
      return a && img ? { url: a.getAttribute('href'), title: a.textContent.trim(), price: price(pr ? pr.textContent : ''), img: big(img), img2: imgs[1] ? big(imgs[1]) : '' } : null;
    }).filter(function (p) { return p && inMenu[p.url.split('?')[0]]; }).slice(0, 8);
    row.innerHTML = items.map(card).join('');
    progress();
    paintHeader();
  }).catch(function () { row.textContent = 'Products could not be loaded.'; });
  function progress() {
    var total = row.scrollWidth || 1;
    bar.style.width = Math.min(100, (row.clientWidth / total) * 100) + '%';
    bar.style.marginLeft = (row.scrollLeft / total) * 100 + '%';
  }
  row.addEventListener('scroll', progress, { passive: true });
  window.addEventListener('resize', progress);

  // Instagram: the posts the shop's Instagram app loads, laid out side by side
  var feed = document.getElementById('insta-feed'), insta = home.querySelector('.bp-insta .bp-row');
  function posts() {
    var items = [].slice.call(feed.querySelectorAll('.instafeed-new-layout-item'));
    if (!items.length) return false;
    insta.innerHTML = items.map(function (it) {
      var a = it.querySelector('a'), src = it.getAttribute('data-instafeed-thumbnail');
      return a && src ? '<a class="bp-post" href="' + a.href + '" target="_blank" rel="noopener"><img src="' + src + '" alt="Instagram post" loading="lazy"></a>' : '';
    }).join('');
    return true;
  }
  if (feed && !posts()) {
    var watch = new MutationObserver(function () { if (posts()) watch.disconnect(); });
    watch.observe(feed, { childList: true, subtree: true });
  }
})();
